import React, { Component } from "react";
import { styles } from "../util/styleDrawComponent";
import "../css/draw-component.scss";
import MarkerIcon from "../../../assets/images/pen_icon.png";
import DrawIcon from "../../../assets/images/draw_icon.svg";
import EraserIcon from "../../../assets/images/eraser_icon.svg";
import CaptureIcon from "../../../assets/images/capture_icon.svg";
import { canCreateCommentPublicUser, canUserNotPermission } from '../authorizations'
import PentoolAlertPopup from './pentoolAlertPopup';
import apiClient from "../util/api-client";

import Alert from "../ui/Alert"
class DrawComponent extends Component {
  constructor(props) {
    super(props);
    const { hidePopupPentoolInstruction } = props;
    this.state = {
      currentTime: 0,
      penCoords: [],
      canvasWidth: 0,
      canvasHeight: 0,
      mode: "draw",
      pen: "up",
      lineWidth: 3,
      penColor: "black",
      isShowPenOption: false,
      showAlert:false,
      isShowEraseAll: false,
      hidePopupPentoolInstruction: hidePopupPentoolInstruction,
      isShowPentoolInstructionModal: false,
      isPenMode: false,
      floatPos: { x: null, y: null },
      isDraggingFloat: false,
      dragOffsetX: 0,
      dragOffsetY: 0,
      activeTool: 'pen',
    };
  }
  renderPenOption = () => {
    return (
      <div>
        <p className="draw_label text-white">Setting</p>
        <div
          className="pen-color"
          style={{ background: this.state.penColor, marginTop: 10 }}
        ></div>
      </div>
    );
  };
  setColor(color) {
    this.setState(
      {
        penColor: color,
      },
      () => {
        const dataDrawSetting = {
          color: this.state.penColor,
          lineWidth: this.state.lineWidth,
        };
        this.props.settingDraw(dataDrawSetting);
      }
    );
  }

  setPenSize(lineWidth) {
    this.setState(
      {
        lineWidth: lineWidth,
      },
      () => {
        const dataDrawSetting = {
          color: this.state.penColor,
          lineWidth: this.state.lineWidth,
        };
        this.props.settingDraw(dataDrawSetting);
      }
    );
  }
  draw(e) {
    this.setState(
      {
        isShowEraseAll: false,
      },
      () => {
        this.props.onClickDraw();
      }
    );
    this.setOption()
  }

  eraser(e) {
    if (!this.state.isShowEraseAll) {
      document.addEventListener("click", this.handleClickOutSideCloseEraseAll, false);
    } else {
      document.removeEventListener("click", this.handleClickOutSideCloseEraseAll, false);
    }
    this.setState(
      {
        isShowPenOption: false,
        isShowEraseAll: !this.state.isShowEraseAll,
      },
      () => {
        this.props.onClickEraser();
      }
    );
  }

  handleClickOutSideCloseEraseAll = (e) => {
    if (e.target.classList.contains('show-erase-all')) {
      return
    }
    this.setState({ isShowEraseAll: false });
  }

  setOption() {
    if (!this.state.isShowPenOption) {
      document.addEventListener("click", this.handleOutsideClick, false);
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
    }
    this.setState((prevState) => ({
      isShowPenOption: !prevState.isShowPenOption,
      isShowEraseAll: false
    }));
  }

  handleOutsideClick = (e) => {
    if (this.node.contains(e.target)) {
      return;
    }
    this.setOption();
  };

  reset() {
    this.setState(
      {
        isShowPenOption: false,
        isShowEraseAll: false,
      },
      () => {
        this.props.onClickReset();
      }
    );
  }

  closeSetting = () => {
    this.setState({
      isShowPenOption: false,
      isShowEraseAll: false,
    });
  };

  capture() {
    this.setState(
      {
        isShowPenOption: false,
        isShowEraseAll: false,
      },
      () => {
        this.props.onClickCapture();
      }
    );
  }

  handleCloseAlert=()=>{
    this.setState({showAlert:false})
  }
  handleEraseAll() {
    this.setState({
      isShowPenOption: false,
      isShowEraseAll: false,
    })
    this.props.onClickEraserAll()
  }
  toggleModeDrawComponentOfDraw = async (isDraw) => {
    const { isShowDrawComponent, toggleShowModalInputInfoOfNotLogin, isInputInfoMationOfNotLogin } = this.props;
    if (isShowDrawComponent) {
      Popup.confirm(
        `ペンツールの作業途中です。<br>画面上部 <span class="img-of-popup-capture"> <img src=${CaptureIcon} width="18"></img></span> からキャプチャ　＞　コメントを保存<br>すると、ペン入力のデータが保存されます。<br>このままペンツールを終了しますか？`,
        {
          success: () => {
            this.handleToggleDrawComponent(isDraw)
          },
          confirmText: 'OK',
        }
      )
    } else {
      if (gon.is_login || isInputInfoMationOfNotLogin) {
        this.handleToggleDrawComponent(isDraw)
      } else {
        toggleShowModalInputInfoOfNotLogin()
      }
    }
  }
  handleToggleDrawComponent = async (isDraw, skipModalCheck = false) => {
    const { toggleModeDrawComponent } = this.props;
    // ペンツール説明モーダルは廃止のためスキップ
    // if (isDraw && !skipModalCheck && !this.state.hidePopupPentoolInstruction) {
    //   this.setState({ isShowPentoolInstructionModal: true })
    //   return
    // }
        
    await toggleModeDrawComponent(isDraw)
    if (isDraw) {
      document.addEventListener("click", this.handleClickOutSideClosePopupDraw, true);
    } else {
      document.removeEventListener("click", this.handleClickOutSideClosePopupDraw, true);
    }
    this.disabledOrEnabledAllTagA(isDraw)
  }

  handleClickOutSideClosePopupDraw = (e) => {    
    if (this.node.contains(e.target) || document.getElementsByClassName('swal2-container ')[0]?.contains(e.target) ||
        document.getElementById('wrap-center').contains(e.target) ||
        !document.getElementsByTagName('body')[0]?.contains(e.target)) {
      return
    }
    e.preventDefault()
    e.stopPropagation()
    if (typeof e.stopImmediatePropagation === 'function') {
      e.stopImmediatePropagation()
    }
    Popup.confirm(
      `ペンツールの作業途中です。<br>画面上部 <span class="img-of-popup-capture"> <img src=${CaptureIcon} width="18"></img></span> からキャプチャ　＞　コメントを保存<br>すると、ペン入力のデータが保存されます。<br>このままペンツールを終了しますか？`,
      {
        success: () => { this.handleToggleDrawComponent(false) },
        confirmText: 'OK',
      }
    )
  }
  disabledOrEnabledAllTagA = (isDisabled) => {
    $(document).find('a').toArray().forEach(a => {
      if (isDisabled) {
        $(a).attr('disabled', true);
        $(a).css('pointer-events', 'none');
      } else {
        $(a).removeAttr('disabled')
        $(a).css('pointer-events', 'auto');
      }
    })
  }

  changeHidePopupPentoolInstruction = (value) => {
    this.setState({ hidePopupPentoolInstruction: value })
  }

  changeNotShowModal = (event) => {
    const isChecked = $(event.target).prop('checked')
    return apiClient()
      .post(
        Routes.hide_popup_pentool_instruction_owner_users_path(),
        { is_show: isChecked }
      ).then((_) => {
        this.changeHidePopupPentoolInstruction(isChecked)
      })
      .catch((e) => {
        Popup.alert(I18n.t('shared.one_error_please_try_again'))
      })
  }

  togglePentoolInstructionModal = async () => {
    const wasOpen = this.state.isShowPentoolInstructionModal
    this.setState({
      isShowPentoolInstructionModal: !this.state.isShowPentoolInstructionModal
    })
    
    if (wasOpen) {
      await this.handleToggleDrawComponent(true, true)
    }
  }
  onFloatBarPointerDown = (e) => {
    if (e.target.closest('div[title]') && !e.target.closest('div[title="ドラッグで移動"]')) return;
    this.setState({ isDraggingFloat: true, dragOffsetX: e.clientX - (this.state.floatPos.x || window.innerWidth-520), dragOffsetY: e.clientY - (this.state.floatPos.y || window.innerHeight-120) });
    e.currentTarget.setPointerCapture(e.pointerId);
    e.stopPropagation();
  }
  onFloatBarPointerMove = (e) => {
    if (!this.state.isDraggingFloat) return;
    const isPhone = window.innerWidth <= 720;
    const newX = Math.max(0, Math.min(window.innerWidth - (isPhone ? 10 : 380), e.clientX - this.state.dragOffsetX));
    const newY = Math.max(0, Math.min(window.innerHeight-70, e.clientY - this.state.dragOffsetY));
    this.setState({ floatPos: { x: newX, y: newY } });
    e.stopPropagation();
  }
  onFloatBarPointerUp = (e) => {
    this.setState({ isDraggingFloat: false });
    e.stopPropagation();
  }

  renderFloatingToolbar() {
    const { floatPos, activeTool, isDraggingFloat } = this.state;
    const isPhone = window.innerWidth <= 720;
    const defaultX = isPhone ? 4 : window.innerWidth - 520;
    const defaultY = isPhone ? window.innerHeight - 80 : window.innerHeight - 120;
    const x = floatPos.x !== null ? floatPos.x : defaultX;
    const y = floatPos.y !== null ? floatPos.y : defaultY;

    return (
      <div
        style={{
          position:'fixed', left:x+'px', top:y+'px', zIndex:2147483600,
          background:'rgba(30,30,30,0.92)', backdropFilter:'blur(12px)',
          borderRadius:'16px', padding: isPhone ? '6px 8px' : '10px 16px',
          boxShadow:'0 8px 32px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.08)',
          display:'flex', alignItems:'center', gap: isPhone ? '4px' : '8px',
          userSelect:'none', cursor: isDraggingFloat ? 'grabbing' : 'default',
          ...(isPhone ? {} : { minWidth:'360px' }),
        }}
        onPointerDown={this.onFloatBarPointerDown}
        onPointerMove={this.onFloatBarPointerMove}
        onPointerUp={this.onFloatBarPointerUp}
      >
        {/* ドラッグハンドル */}
        <div style={{cursor:'grab', color:'rgba(255,255,255,0.3)', fontSize:'18px', lineHeight:1, marginRight:'4px'}}
             title="ドラッグで移動">⠿</div>

        {/* ペンツール */}
        <div title="ペン" onClick={(e)=>{e.stopPropagation();this.setState({activeTool:'pen'});this.draw(e);}}
          style={{
            width: isPhone ? 28 : 36, height: isPhone ? 28 : 36, borderRadius:'10px', display:'flex', alignItems:'center', justifyContent:'center',
            cursor:'pointer', background: activeTool==='pen' ? 'rgba(255,107,43,0.3)' : 'transparent',
            border: activeTool==='pen' ? '1px solid #ff6b2b' : '1px solid transparent',
            color: activeTool==='pen' ? '#ff6b2b' : 'rgba(255,255,255,0.7)',
            transition:'all 0.15s',
          }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/>
          </svg>
        </div>

        {/* 消しゴム */}
        <div title="消しゴム（全消去）" onClick={(e)=>{e.stopPropagation();this.setState({activeTool:'eraser'});this.handleEraseAll();}}
          style={{
            width: isPhone ? 28 : 36, height: isPhone ? 28 : 36, borderRadius:'10px', display:'flex', alignItems:'center', justifyContent:'center',
            cursor:'pointer', background: activeTool==='eraser' ? 'rgba(255,59,59,0.2)' : 'transparent',
            border: activeTool==='eraser' ? '1px solid #ff3b3b' : '1px solid transparent',
            color: activeTool==='eraser' ? '#ff3b3b' : 'rgba(255,255,255,0.7)',
            transition:'all 0.15s',
          }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 20H7L3 16l10-10 7 7-1.5 1.5"/><path d="M6.5 17.5l5-5"/>
          </svg>
        </div>

        {/* 区切り線 */}
        <div style={{width:'1px', height: isPhone ? '18px' : '24px', background:'rgba(255,255,255,0.15)', margin:'0 2px'}}></div>

        {/* 太さ選択 */}
        {[3,6,9,12,15].map(size => (
          <div key={size} title={`太さ ${size}`}
            onClick={(e)=>{e.stopPropagation();this.setPenSize(size);}}
            style={{
              width: (isPhone ? 6+size : 8+size)+'px', height: (isPhone ? 6+size : 8+size)+'px',
              borderRadius:'50%', cursor:'pointer',
              background: this.state.lineWidth===size ? this.state.penColor : 'rgba(255,255,255,0.5)',
              border: this.state.lineWidth===size ? '2px solid white' : '2px solid transparent',
              transition:'all 0.15s', flexShrink:0,
            }}
          />
        ))}

        {/* 区切り線 */}
        <div style={{width:'1px', height: isPhone ? '18px' : '24px', background:'rgba(255,255,255,0.15)', margin:'0 2px'}}></div>

        {/* カラーパレット（主要6色） */}
        {['black','red','orange','gold','limegreen','blue'].map(color => (
          <div key={color} title={color}
            onClick={(e)=>{e.stopPropagation();this.setColor(color);}}
            style={{
              width: isPhone ? 17 : 22, height: isPhone ? 17 : 22, borderRadius:'50%', cursor:'pointer',
              background:color,
              border: this.state.penColor===color ? '3px solid white' : '2px solid rgba(255,255,255,0.2)',
              transition:'all 0.15s', flexShrink:0,
            }}
          />
        ))}

        {/* 区切り線 */}
        <div style={{width:'1px', height: isPhone ? '18px' : '24px', background:'rgba(255,255,255,0.15)', margin:'0 2px'}}></div>

        {/* キャプチャ保存 */}
        <div title="キャプチャしてコメント保存" onClick={(e)=>{e.stopPropagation();this.capture(e);}}
          style={{
            width: isPhone ? 28 : 36, height: isPhone ? 28 : 36, borderRadius:'10px', display:'flex', alignItems:'center', justifyContent:'center',
            cursor:'pointer', background:'rgba(34,197,94,0.2)',
            border:'1px solid rgba(34,197,94,0.5)', color:'#22c55e', transition:'all 0.15s',
          }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
            <circle cx="12" cy="13" r="4"/>
          </svg>
        </div>

        {/* 終了ボタン */}
        <div title="ペンモード終了" onClick={(e)=>{e.stopPropagation();this.toggleModeDrawComponentOfDraw(false);}}
          style={{
            width: isPhone ? 28 : 36, height: isPhone ? 28 : 36, borderRadius:'10px', display:'flex', alignItems:'center', justifyContent:'center',
            cursor:'pointer', background:'rgba(255,255,255,0.05)',
            border:'1px solid rgba(255,255,255,0.15)', color:'rgba(255,255,255,0.6)', transition:'all 0.15s',
            marginLeft:'4px',
          }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </div>
      </div>
    );
  }

  render() {
    const { mobile, toggleModeDrawComponent, isShowDrawComponent, currentAnimation, role } = this.props;
    const { showAlert, isShowPentoolInstructionModal, hidePopupPentoolInstruction } = this.state
    const opacityStyle = currentAnimation?.need_conversion ? 0.6 : 1;
    return (
      <div className={isShowDrawComponent ? 'right-component' : ''} style={{ display: "flex", marginBottom: '0px', alignItems: "center", position: 'relative',}}>
        <Alert handleChange={this.handleCloseAlert} content="拡大・縮小が100%以外の時はご利用できません" open={showAlert}/>
        {/* PentoolAlertPopup 廃止 */}
        {/* <PentoolAlertPopup
          isOpen={isShowPentoolInstructionModal}
          isNotShowPentoolInstruction={hidePopupPentoolInstruction}
          changeNotShowModal={this.changeNotShowModal}
          togglePopup={this.togglePentoolInstructionModal}
        /> */}
          {/* <div className="div_marker text-center d-flex" onClick={() => toggleModeDrawComponent(!isShowDrawComponent)} style={mobile ? {height: 45} : {}}>
            <div className="text-center">
              <img src={MarkerlIcon}></img>
            </div>
          </div> */}
          <div ref={(node) => { this.node = node; }} style={{position:'relative', display:'contents'}}>

            {/* ペンモードボタン */}
            <div
              onPointerDown={(e) => { e.stopPropagation(); e.preventDefault(); this.toggleModeDrawComponentOfDraw(!isShowDrawComponent); }}
              onClick={(e) => { e.stopPropagation(); }}
              style={{
                display:'inline-flex', alignItems:'center', gap:'5px',
                cursor: (!this.props.isCommentMode || currentAnimation?.need_conversion) ? 'not-allowed' : 'pointer',
                opacity: (!this.props.isCommentMode || currentAnimation?.need_conversion) ? 0.4 : 1,
                pointerEvents: (!this.props.isCommentMode || currentAnimation?.need_conversion) ? 'none' : 'auto',
                userSelect:'none', whiteSpace:'nowrap',
                background: isShowDrawComponent ? '#ff6b2b' : '#1e1e3a',
                color: isShowDrawComponent ? '#fff' : '#cdd6f4',
                border: isShowDrawComponent ? 'none' : '1px solid #2a2a4a',
                borderRadius:'6px', padding:'4px 10px', fontSize:'12px', fontWeight:'600',
                marginRight:'10px',
              }}
              className={currentAnimation?.need_conversion ? 'disabled' : ''}
            >
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/>
              </svg>
              <span>{isShowDrawComponent ? 'ペンモード' : 'テキストモード'}</span>
            </div>

            {/* フローティングツールバー（ペンモード時のみ表示） */}
            {isShowDrawComponent && this.renderFloatingToolbar()}

          </div>
      </div>
    );
  }
}

export default DrawComponent;
